import { Colli } from '@frontend/colli/types';

/** True when the device has a location set and the colli's current spot differs from it. */
export const isColliAtOtherLocation = (colli: Colli, deviceSpotId: string | undefined): boolean => !!deviceSpotId && colli.current_spot_id !== deviceSpotId;
